// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SidepanelItemSource} from 'constants/SourceConstants';
import FinderUtil from 'file-browser/FinderUtil';
import NoteConstants from 'notebook/notes/NoteConstants';
import {ListableItem} from 'search/SearchConstants';
import APIUtil from 'util/APIUtil';
import BenchlingData, {FileJson, FILES_MIME_TYPE, SOURCES_MIME_TYPE} from 'util/drag-and-drop/BenchlingData';
import {omit} from 'util/omitKey';
import * as ShortcutUtil from 'util/ShortcutUtil';
import {ElementDragEvent} from 'util/Types';
import {getWorkflowURL} from 'workflows/util/WorkflowUtil';

const {FOLDER, SOURCE, WORKFLOW} = ModelTypeConstants;

interface DraggableComponentProps {
  draggable: true;
  onDragStart: (e: ElementDragEvent) => void;
}

export interface FileDragTargetProps {
  component:
    | string
    | React.FunctionComponent<DraggableComponentProps>
    | React.ComponentClass<DraggableComponentProps, unknown>;
  children: React.ReactNode;
  finderId?: string | null;
  onDragStart?: (e: ElementDragEvent) => void;
  result: ListableItem | SidepanelItemSource;
}

export default class FileDragTarget extends React.Component<FileDragTargetProps> {
  static defaultProps = {
    component: 'div',
  };

  dragStartHandler = (e: ElementDragEvent): void => {
    // eslint-disable-next-line new-cap
    const bd = BenchlingData(e);
    e.dataTransfer.effectAllowed = 'all';
    e.dataTransfer.dropEffect = 'move';

    const {result} = this.props;
    const modelType = APIUtil.apiIdToType(result.id);

    // TODO: See T1711.
    // workspaceItem doesn't have the url available (for now). So we compute the URL here, to be
    // used in the case of source / file / folder
    const relativeURL = (() => {
      switch (modelType) {
        case SOURCE:
        case FOLDER:
          // @ts-expect-error `SourceSummary` and `FolderSummary` both have `url` but TS doesn't know that
          // that is what `result` is just from this `switch`
          return result.url;
        case WORKFLOW:
          return getWorkflowURL(result.id);
        default:
          // @ts-expect-error Similarly, things that are not source / folder / workflow all have `editUrl` but
          // TS doesn't know that just from switching on the model type
          return result.editURL;
      }
    })();
    if (relativeURL) {
      const absoluteURL = `${document.location.origin}${relativeURL}`;
      // We call setLink first because otherwise the benchling data gets wipes.
      // See: https://bugs.webkit.org/show_bug.cgi?id=142843
      bd.setLink(result.name, absoluteURL);
    }

    if (modelType === SOURCE) {
      bd.setData<typeof SOURCES_MIME_TYPE>(SOURCES_MIME_TYPE, [
        {
          ...result,
          benchlingDataType: SOURCES_MIME_TYPE,
        },
      ]);
    } else if (NoteConstants.NOTE_PREVIEW_SUPPORTED_TYPES.includes(modelType) || modelType === FOLDER) {
      // @ts-expect-error `FolderSummary` has `source` but TS doesn't know that that is what `result` is from
      // this conditional; ditto `result` being a folder item if it is not a folder
      const source = modelType === ModelTypeConstants.FOLDER ? result.source : result.folder.source;
      const isShortcut =
        this.props.finderId != null ? ShortcutUtil.shouldShowShortcut(result, this.props.finderId) : null;
      const fileJSON: FileJson = {
        benchlingDataType: FILES_MIME_TYPE,
        id: result.id,
        isShortcut: isShortcut ?? false,
        name: result.name,
        url: relativeURL,
        permissions: result.permissions,
        // @ts-expect-error `isShortcut` not sufficient for TS to know `result` is a folder item
        parentFolderId: isShortcut ? result.projectFolderId : FinderUtil.parentFolderId(result),
        source,
        // @ts-expect-error `FolderSummary` has `type` but TS doesn't know that that is what `result` is from
        // this conditional
        type: modelType === ModelTypeConstants.FOLDER ? result.type : null,
      };
      bd.setData<typeof FILES_MIME_TYPE>(FILES_MIME_TYPE, [fileJSON]);
    }

    if (typeof this.props.onDragStart === 'function') {
      this.props.onDragStart(e);
    }
  };

  render(): JSX.Element {
    const propsForComponent = omit(this.props, 'component', 'result', 'finderId');
    return React.createElement(
      this.props.component,
      {...propsForComponent, draggable: true, onDragStart: this.dragStartHandler},
      this.props.children
    );
  }
}
